import { Link } from "@tanstack/react-router";
import { Clock } from "lucide-react";

import { PageHero } from "@/components/layout/PageHero";
import { blog } from "@/content/blog";
import { pages } from "@/content/pages";
import type { Locale } from "@/i18n/locales";
import { localePath } from "@/i18n/locales";

type BlogIndexViewProps = {
  locale: Locale;
};

export function BlogIndexView({ locale }: BlogIndexViewProps) {
  const copy = pages[locale].blog;
  const posts = blog[locale];

  return (
    <main className="bg-background">
      <PageHero eyebrow={copy.eyebrow} title={copy.title} intro={copy.intro} />

      <section className="pb-24">
        <div className="mx-auto max-w-5xl px-5">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((post) => (
              <article
                key={post.slug}
                className="h-full overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition-shadow duration-300 hover:shadow-md"
              >
                <Link
                  to={localePath(locale, `/blog/${post.slug}`)}
                  className="group flex h-full flex-col"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={post.image}
                      alt=""
                      width={800}
                      height={450}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-5">
                    <div className="mb-3 flex items-center gap-3">
                      <span className="text-xs font-bold uppercase tracking-widest text-primary">
                        {post.category}
                      </span>
                      <span className="flex items-center gap-1 text-xs text-muted-foreground">
                        <Clock className="h-3 w-3" /> {post.readTime}
                      </span>
                    </div>
                    <h2 className="mb-2 font-heading text-base font-bold leading-snug text-[#1a3a5c] transition-colors group-hover:text-primary">
                      {post.title}
                    </h2>
                    <p className="text-sm leading-relaxed text-muted-foreground">
                      {post.excerpt}
                    </p>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
